import React from "react";
import {
  Table as AntTable,
  Space,
  Avatar,
  Popconfirm,
  Input,
  Button,
  Switch,
} from "antd";
import { useState, useRef } from "react";
import { UserOutlined, SearchOutlined } from "@ant-design/icons";
import { useStateContext } from "../../../../contexts/ContextProvider";

const headerStyle = {
  color: "#525252",
};

const Table = ({ data, onEdit, onEditCase, onDelete, onToggleEnable, togglingId, loading }) => {
  const { currentColor } = useStateContext();
  const [setSearchText] = useState("");
  const [setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    {
      title: "แสดง",
      align: "center",
      width: 80,
      key: "enable",
      render: (record) => (
        <Switch
          size="small"
          checked={Number(record.enable) !== 0}
          loading={togglingId === record.id}
          onChange={(checked) => onToggleEnable && onToggleEnable(record, checked)}
        />
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      title: "ลำดับ",
      align: "center",
      width: 60,
      dataIndex: "number",
      key: "number",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "CaseName",
      align: "center",
      dataIndex: "casename",
      key: "casename",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
      ...getColumnSearchProps("casename"),
    },
    {
      title: "หมายเหตุ",
      align: "center",
      dataIndex: "remark",
      key: "remark",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
      // ...getColumnSearchProps("remark"),
    },
    {
      title: "Create Date",
      align: "center",
      dataIndex: "create_date",
      key: "create_date",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "การจัดการ",
      fixed: "right",
      key: "actions",
      align: "center",
      render: (record) => (
        <Space size="middle">
          <Button type="primary" style={{backgroundColor: '#f97316'}} onClick={() => onEdit(record)}>
            Subcase
          </Button>
          <Button type="primary" onClick={() => onEditCase(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this case?"
            onConfirm={() => onDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" danger>Delete</Button>
          </Popconfirm>
          
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    },
  ];

  return (
    <div className="overflow-x-auto">
      <AntTable
        loading={loading}
        className="border-1 rounded-lg border-gray-200"
        dataSource={data}
        columns={columns}
        pagination={{ pageSize: 8 }}
        rowKey={"id"}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default Table;
